import { FC, useState } from 'react'
import dayjs, { Dayjs } from 'dayjs'
import ManagerMonthlySummary from './components/manager-monthly-summary'

const ManagerContent: FC = () => {
    const [month, setMonth] = useState<Dayjs>(() => dayjs())

    return <ManagerMonthlySummary month={month} onMonthChange={setMonth} />
}

export default ManagerContent
